import {Directive, OnInit, Optional} from '@angular/core';
import {MatOption} from '@angular/material/core';
import {AppSelectElementDirective, AppSelectElementInterface} from '@component/form/input/select/select-element.directive';
import {AbstractSearchSelectDirective} from '@component/form/input/select/abstract-search-select.directive';

@Directive({
    selector: '[appSelectExamOption]',
})
export class AppSelectExamOptionDirective extends AbstractSearchSelectDirective implements OnInit, AppSelectElementInterface {
    constructor(
        option: MatOption,
        @Optional() select: AppSelectElementDirective,
    ) {
        super(option, select);
    }
}
